import { FC } from "react";
import { Flex } from "@smile2impress/components/relaunch";
import { Icon, Icons } from "@smile2impress/components";
import { UniversalTextElement } from "templates/relaunch/primitives/UniversalTextElement";

import { ListItemProps } from "./ListItem.types";

export const ListItem: FC<ListItemProps> = ({
    title,
    text = "",
    icon,
    isCmsContent,
    iconOnTop = false,
}) => {
    const iconComponent =
        typeof icon === "string" ? Icons[icon as keyof typeof Icons] : icon;

    return (
        <Flex
            direction={
                iconOnTop
                    ? ["column"]
                    : ["row-reverse", "row-reverse", "column"]
            }
        >
            {iconComponent && (
                <Flex
                    ml={iconOnTop ? [0] : [4, 4, 0]}
                    mb={iconOnTop ? [2, 2, 0.7] : [0, 0, 0.7]}
                >
                    <Icon
                        w={3}
                        h={3}
                        as={iconComponent}
                        color="base.bitterSweet"
                    />
                </Flex>
            )}
            <UniversalTextElement
                title={title}
                text={text}
                extraTitleStyles={{
                    textTransform: "uppercase",
                    ...(isCmsContent ? { mb: 2 } : {}),
                    as: "h3",
                }}
                {...(isCmsContent && {
                    isCmsContent: true,
                })}
            />
        </Flex>
    );
};
